import React from 'react';
import { _ } from "../utils";
import './sidebox.less';

export default ({ buyUrl }) => (
    <div className="sidebox">
        <div className="sidebox-title">
            <i className="fa fa-files-o"></i>
            <h1 className="col-10">{_('Pronađite najboljeg zaposlenika')}</h1>
        </div>
        <div className="sidebox-body">
            <a href={buyUrl} className="btn btn-primary">{_('Kupi kredite')}</a>
        </div>
    </div>
);


// WEBPACK FOOTER //
// ./src/modules/app/Sidebox.js